var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolkswagen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0045 0C17.0613 0 22 4.93902 22 11.0045C22 17.0521 17.0611 22.0001 11.0045 22.0001C4.94794 22.0001 2.85705e-09 17.0521 2.85705e-09 11.0045C-0.000137291 4.93888 4.94794 0 11.0045 0Z",
    fill: "#295CA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0048 1.39697C16.2862 1.39697 20.6035 5.71405 20.6035 11.0047C20.6035 16.2862 16.2863 20.5943 11.0048 20.5943C5.72319 20.5943 1.40625 16.2861 1.40625 11.0045C1.40625 5.71405 5.72319 1.39697 11.0048 1.39697ZM4.57857 5.84022L8.02149 14.7719L9.28322 11.5092H12.5909L13.8525 14.7719L17.3315 5.73203C16.7176 4.99139 15.9796 4.36319 15.1503 3.87554L12.7351 10.5269H9.32812L6.90391 3.84836C6.01164 4.36211 5.22755 5.03815 4.57857 5.84022ZM18.7197 8.08443L14.799 18.3139C17.4309 16.935 19.2423 14.1771 19.2423 11.0047C19.2423 9.97717 19.0621 8.99469 18.7197 8.08443ZM13.0865 18.9808L13.0598 18.7735L10.9325 13.2577L8.80557 18.7735L8.79665 18.9448C9.4996 19.1429 10.2387 19.2422 11.0048 19.2422C11.7257 19.2422 12.4197 19.1521 13.0865 18.9808ZM7.04807 18.2237L3.22677 8.2647C2.92033 9.12086 2.75805 10.0402 2.75805 11.0045C2.75805 14.1049 4.4885 16.8266 7.04807 18.2237ZM11.0048 2.75783C11.7257 2.75783 12.4377 2.84803 13.1137 3.02816L11.0318 8.78738L8.94081 3.01924C9.6149 2.84482 10.3085 2.75698 11.0048 2.75783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolkswagen);
export default __webpack_public_path__ + "static/media/volkswagen.591e968424eca1152bb86a90743c1e62.svg";
export { ForwardRef as ReactComponent };